import React from "react";
import "./FAQ.css";
import useWindowDimensions from "../../components/getWindowDimensions";

function FAQ() {
  const width = useWindowDimensions().width;

  const faqs = [
    {
      question: "How do I schedule?",
      answer:
        'Press the "Book" button on the right top corner of this page and just follow the required steps for booking. You can also call or text me at (336)552-0796 and I\'ll do the reservation for you.',
      special: false,
    },
    {
      question: "How do I cancel or reschedule?",
      answer:
        'I ask for a 24hrs cancellation notice. There is a link in the confirmation email of your reservation that says "cancel or reschedule" you can follow that link or call or text me ASAP at (336)552-0796.',
      special: false,
    },
    {
      question: "How do I get there?",
      answer:
        'Press "The Studio" button on the right top corner of this page to see detailed information. Also there are instructions in the first confirmation email of your reservation.',
      special: false,
    },
    {
      question: "Is there parking available?",
      answer: "Yes, there is always a saved parking space for you.",
      special: false,
    },
    {
      question: "What time should I arrive?",
      answer:
        "You should arrive right at the time of your reservation. Please notice that there is no waiting room inside the studio. If you happen to be here a couple of minutes earlier, you are welcome to seat in the bench or table outside the studio.",
      special: false,
    },
    {
      question:
        "I am pregnant/older/younger/underweight/overweight/out of shape/in great shape... can you see me anyways?",
      answer: "Absolutely. My services are customized for everyone needs.",
      special: true,
    },
    {
      question: "How do I prepare for the massage?",
      answer:
        "If you can, hydrate the tissues of your body by drinking water and taking a shower or bath before the service. That helps the massage being more effective by starting the process in stimulating the lymphatic and circulatory systems, making the tissues more malleable and calming the mind.",
      special: false,
    },
    {
      question: "When should I reschedule my massage?",
      answer:
        "If you currently have:<ul><li><strong>High Fever</strong>: Fever indicates a systemic issue that may worsen with massage</li><li>An <strong>acute infection</strong> in any part of the body</li><li>A <strong>contagious disease like flu or any viral/bacterial like cold, cough</strong>…</li><li><strong>Extensive; skin rash, ring worm, open wounds</strong> (Small areas can be avoided and massage the rest of the body can be safe but it depends on case to case)</li><li><strong>Recent surgery</strong>; for proper healing allow 6-9 months after surgery to schedule a massage</li><li><strong>Recent Broken Bones/Fractures</strong> for proper healing allow 6-9 months after the incident to schedule a massage</li></ul>",
      special: false,
      html: true,
    },
    {
      question: "How are the times of the session?",
      answer:
        "Your session time starts right at the time of your reservation with your arrival at the Studio. I dedicate 10-15 minutes to welcome you, consultation, undressing/dressing, feedback and check out. Leaving us with the rest of the time for hands-on body work.",
      special: false,
    },
    {
      question: "How often do I need to receive a massage?",
      answer:
        "It all depends on each individual and specific condition, as everyone is unique.",
      special: false,
    },
  ];

  if (width < 1250) {
    return (
      <React.Fragment>
        <div className="FAQ-mandala-container FAQ-mandala-container-resized flex-column">
          <span className="recoleta medium">About your visit and more...</span>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="flex-column FAQ-text-container-resized"
              style={faq.special ? { wordWrap: "break-word" } : undefined}
            >
              <span className={`bold${faq.special ? " text-break" : ""}`}>
                {faq.question}
              </span>
              {faq.html ? (
                <span dangerouslySetInnerHTML={{ __html: faq.answer }}></span>
              ) : (
                <span>{faq.answer}</span>
              )}
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="FAQ-mandala-container flex-column">
          <span className="recoleta medium">About your visit and more...</span>
          {faqs.map((faq, index) => (
            <div key={index} className="flex-column FAQ-text-container">
              <span className="bold">{faq.question}</span>
              {faq.html ? (
                <span dangerouslySetInnerHTML={{ __html: faq.answer }}></span>
              ) : (
                <span>{faq.answer}</span>
              )}
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default FAQ;
